module.exports = "<div class=\"success-container\">\n        {{message}}\n</div>"